/**
 * Public-safe dealer lead preference helpers (Lead Flow M22).
 */

export const DEALER_LEAD_CAPTURE_UNAVAILABLE_ES = "Contacto no disponible por ahora.";

/**
 * @param {object|null|undefined} dealer
 * @returns {string|null}
 */
export function getDealerLeadCaptureBlockReason(dealer) {
  if (!dealer) return null;

  const leadCapture = dealer.leadCapture;
  if (leadCapture && leadCapture.enabled === false) {
    return "leads_disabled";
  }
  if (leadCapture?.contactAvailability === "unavailable") {
    return "contact_unavailable";
  }

  if (dealer.leadsEnabled === false) return "leads_disabled";
  if (dealer.leadRoutingMode === "disabled") return "routing_disabled";
  if (dealer.leadContactAvailability === "unavailable") return "contact_unavailable";

  return null;
}

/**
 * @param {object|null|undefined} dealer
 */
export function isDealerLeadCaptureEnabled(dealer) {
  return getDealerLeadCaptureBlockReason(dealer) == null;
}

/**
 * @param {object|null|undefined} dealer
 */
export function getDealerLeadCaptureBuyerMessage(dealer) {
  if (!isDealerLeadCaptureEnabled(dealer)) {
    return DEALER_LEAD_CAPTURE_UNAVAILABLE_ES;
  }
  return null;
}

/**
 * Maps admin contact availability to directory-safe availability token.
 * @param {object|null|undefined} dealer
 */
export function getPublicContactAvailabilityFromDealer(dealer) {
  const leadCapture = dealer?.leadCapture;
  if (leadCapture?.contactAvailability) {
    return leadCapture.contactAvailability;
  }
  if (dealer?.leadContactAvailability) {
    return dealer.leadContactAvailability;
  }
  return null;
}
